export default __webpack_public_path__ + "static/media/img_result_line5.6a608af7.svg";